import { Component, OnInit } from '@angular/core';
import { ServerService } from '../services/server.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
declare var iziToast: any;
declare var $: any;
import Swal from 'sweetalert2';
declare var tinymce: any;
import * as Feather from 'feather-icons';
@Component({
  selector: 'app-support-ticket',
  templateUrl: './support-ticket.component.html',
  styleUrls: ['./support-ticket.component.css']
})
export class SupportTicketComponent implements OnInit {
  recordNotFound = false;
  pageLimit = 50;
  paginationData: any = { "info": "hide" };
  offset_count = 0;
  counts: any = {};
  recordNotFound2 = false;
  pageLimit2 = 10;
  paginationData2: any = { "info": "hide" };
  offset_count2 = 0;


  opentickets: any = [];
  closetickets: any = [];

  files: any = [];
  filesend: any = [];
  createinformation: FormGroup;
  value;
  customerdetails: any = {};
  datadetails: any;
  param1: any;
  param2: any;
  table = false;
  close_table = false;
  new_table = false;
  closedtickets: any;
  new_ticket;
  countryList:any;
  priorityList:any;
  supportRequestTypeList:any;
  create_ticket_loader = false;
 
  constructor(private router: Router, private serverService: ServerService, private route: ActivatedRoute,) {
    this.param1 = this.route.snapshot.queryParamMap.get('name');
    this.param2 = this.route.snapshot.queryParamMap.get('id');
    this.serverService.emailcount.subscribe( (val:any) => 
    {
      this.create_ticket_loader=true;
          console.log(val);
          this.newticket({});
          this.ticket_count();
    })
 }

  ngOnInit(): void {
    this.serverService.popup.subscribe((val: any) => {
      console.log(val);
      let viewContent = JSON.parse(val);
      console.log(viewContent);
      if (viewContent.type === 'create_ticket') {
        $('#addNewPopup').modal('show');
        this.jiraDropdown();
      }
    });
    this.jiraDropdown();
    this.countryflag();
    this.open_ticket({});
    this.ticket_count();
    this.initTiny();
    
    this.createinformation = new FormGroup({
      'fromticket': new FormControl(null,
        Validators.required),
      // 'department': new FormControl(null),
      'country':new FormControl(null, Validators.required),
      'priority': new FormControl(null, Validators.required),
      'requestType':new FormControl(null, Validators.required),
      'subject': new FormControl(null, Validators.required),
      'messages': new FormControl(null)

    });
    this.param1 = atob(this.param1)
    this.param2 = atob(this.param2)
    if (this.param1 == 'open') {
      this.table = true;
    }
    if (this.param2 == 'new') {
      this.new_table = true;
    }
    if (this.param2 == 'closed') {
      this.close_table = true;
    }
  }

  ngAfterViewInit() {
    Feather.replace();
  }

  finishFunction() {
    // console.log(this.idmessage)
    // console.log($('#idmessage').val())
    // console.log(this.value)

    console.log(this.createinformation.value)
    if (this.createinformation.valid) {
      console.log('hai');
      this.createnewticket();
    }
    else {

      this.validateAllFields(this.createinformation);
    }
    this.createinformation.reset();
  }



  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }


  localUrl;
  file: File;
  uploadFiless(event) {
    console.log(event[0])
    this.file = event[0];
    if (event[0] != undefined) {
      this.filesend.push(event[0])

    }

    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.files.push(element.name);
    }
    console.log(this.filesend)




  }



  uploadFile(event: any) {
    this.file = event.target.files[0];

    console.log(this.file)
    if (this.file != undefined) {

      this.filesend.push(this.file)
    }
    var events = event.target.files;
    for (let index = 0; index < events.length; index++) {
      const element = events[index];
      this.files.push(element.name)
    }

    console.log(this.filesend)

  }



  deleteAttachment(i) {
    this.files.splice(i, 1);
    this.filesend.splice(i, 1);
  }


  gotck(ticket) {
    var tck = btoa(ticket);
    $('.pointer').addClass('read-color-change');
    // localStorage.setItem('tck',tck); 
    this.router.navigate(['support-ticket-thread'], { queryParams: { id: tck } });

  }



  // open_ticket(data){
  //    Swal.fire('Please wait')
  // Swal.showLoading()
  //     var list_data= this.listDataInfo(data);


  //   let datas:any =new Object();
  //  let datasend:any = new Object();
  //     let access_token: any=localStorage.getItem('at');
  //     let customer_id: any=localStorage.getItem('en');


  // datas.action="open_ticket";
  // datas.customer_id = customer_id;
  // datas.limit = list_data.limit;
  // datas.offset = list_data.offset;


  //  datasend.access_token=access_token;
  //   datasend.operation="curlDatas";
  //   datasend.moduleType="login";
  //   datasend.api_type="web";
  //   datasend.element_data = datas;
  //       this.serverService.sendServer(datasend).subscribe((response: any) => {
  // console.log(response)
  //  Swal.close();
  //         // if(response.status=="true"){
  //      this.opentickets = response.open

  // //           }
  // //         else{
  // // this.opentickets =[];

  // //         }
  //    this.offset_count = list_data.offset;
  //         this.paginationData = this.serverService.pagination({'offset':response.Offset, 'total':response.Total, 'page_limit' :this.pageLimit });
  //          console.log(this.paginationData);
  //                 this.recordNotFound = this.opentickets.length == 0 ? true : false;



  //       }, 
  //       (error)=>{
  //           console.log(error);
  //       });

  // }

  open_ticket(data) {
    Swal.fire('Please wait')
    Swal.showLoading()
    var list_data = this.listDataInfo(data);


    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    // datas.action="omni_newticket";
    datas.action = "omni_openticket";
    // datas.customer_id = 'MzQ5';
    datas.customer_id = customer_id;
    datas.limit = list_data.limit;
    datas.offset = list_data.offset;


    datasend.access_token = access_token;
    datasend.operation = "omniCurl";
    datasend.moduleType = "ticket";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      Swal.close();
      if (response.result.status == true) {
        this.opentickets = response.result.data.open;
        console.log(this.opentickets);
      } else {
        this.opentickets = [];
        console.log(this.opentickets);
      }
      this.offset_count = list_data.offset;
      this.paginationData = this.serverService.pagination({ 'offset': response.Offset, 'total': response.Total, 'page_limit': this.pageLimit });
      console.log(this.paginationData);
      this.recordNotFound = this.opentickets.length == 0 ? true : false;



    },
      (error) => {
        console.log(error);
      });

  }

  newticket(data) {
    if(this.create_ticket_loader == false){
      Swal.fire('Please wait')
      Swal.showLoading()
    }
    
    var list_data = this.listDataInfo(data);


    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    // datas.action="omni_openticket";
    datas.action = "omni_newticket";
    // datas.customer_id = 'MzQ5';
    datas.customer_id = customer_id;
    datas.limit = list_data.limit;
    datas.offset = list_data.offset;


    datasend.access_token = access_token;
    datasend.operation = "omniCurl";
    datasend.moduleType = "ticket";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      Swal.close();
      //        if(response.result.status==true){
      //     this.new_ticket = response.result.data.new;
      //   console.log(this.new_ticket);
      //           }else{
      // this.new_ticket =[];
      // console.log(this.new_ticket);
      //         }
      //   this.offset_count = list_data.offset;
      //        this.paginationData = this.serverService.pagination({'offset':response.Offset, 'total':response.Total, 'page_limit' :this.pageLimit });
      //         console.log(this.paginationData);
      //                this.recordNotFound = this.new_ticket.length == 0 ? true : false;
      if (response.result.status == true) {
        this.opentickets = response.result.data.new;
        console.log(this.opentickets);
        this.create_ticket_loader = false;
      } else {
        this.opentickets = [];
        console.log(this.opentickets);
        this.create_ticket_loader = false;
      }
      this.offset_count = list_data.offset;
      this.paginationData = this.serverService.pagination({ 'offset': response.Offset, 'total': response.Total, 'page_limit': this.pageLimit });
      console.log(this.paginationData);
      this.recordNotFound = this.opentickets.length == 0 ? true : false;



    },
      (error) => {
        console.log(error);
      });

  }


  close_ticket(data) {
    Swal.fire('Please wait')
    Swal.showLoading()
    var list_data = this.listDataInfo(data);


    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    datas.action = "omni_closedticket";
    // datas.customer_id = 'MzQ5';
    datas.customer_id = customer_id;
    datas.limit = list_data.limit;
    datas.offset = list_data.offset;


    datasend.access_token = access_token;
    datasend.operation = "omniCurl";
    datasend.moduleType = "ticket";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      Swal.close();
      //        if(response.result.status==true){
      //     this.closedtickets = response.result.data.closed;
      //   console.log(this.closedtickets);
      //           }else{
      // this.closedtickets =[];
      // console.log(this.closedtickets);
      //         }
      //   this.offset_count = list_data.offset;
      //        this.paginationData = this.serverService.pagination({'offset':response.Offset, 'total':response.Total, 'page_limit' :this.pageLimit });
      //         console.log(this.paginationData);
      //                this.recordNotFound = this.closedtickets.length == 0 ? true : false;
      if (response.result.status == true) {
        this.opentickets = response.result.data.closed;
        console.log(this.opentickets);
      } else {
        this.opentickets = [];
        console.log(this.opentickets);
      }
      this.offset_count = list_data.offset;
      this.paginationData = this.serverService.pagination({ 'offset': response.Offset, 'total': response.Total, 'page_limit': this.pageLimit });
      console.log(this.paginationData);
      this.recordNotFound = this.opentickets.length == 0 ? true : false;



    },
      (error) => {
        console.log(error);
      });

  }


  listDataInfo(list_data) {
    console.log(list_data)
    list_data.search_text = list_data.search_text == undefined ? "" : list_data.search_text;
    // list_data.order_by_name = list_data.order_by_name == undefined ? "user.user_id" : list_data.order_by_name;
    // list_data.order_by_type = list_data.order_by_type == undefined ? "desc" : list_data.order_by_type;
    list_data.limit = list_data.limit == undefined ? this.pageLimit : list_data.limit;
    list_data.offset = list_data.offset == undefined ? 0 : list_data.offset;
    return list_data;
  }

  getsearch(searchValue: string): void {
    console.log(searchValue);
    this.open_ticket({ 'search_text': searchValue })
  }
  getsearch3(searchValue: string): void {
    console.log(searchValue);
    this.close_ticket({ 'search_text': searchValue })
  }


  // closedticket(data){
  //     var list_data2= this.listDataInfo2(data);


  //   let datas:any =new Object();
  //  let datasend:any = new Object();
  //     let access_token: any=localStorage.getItem('at');
  //     let customer_id: any=localStorage.getItem('en');


  // datas.action="closed_ticket";
  // datas.customer_id = customer_id;
  // datas.limit = list_data2.limit;
  // datas.offset = list_data2.offset;


  //  datasend.access_token=access_token;
  //   datasend.operation="curlDatas";
  //   datasend.moduleType="login";
  //   datasend.api_type="web";
  //   datasend.element_data = datas;
  //       this.serverService.sendServer(datasend).subscribe((response: any) => {
  // console.log(response)
  //         // if(response.status=="true"){
  //      this.closetickets = response.closed

  //           // }
  // //         else{
  // // this.closetickets =[];

  // //         }
  //    this.offset_count2 = list_data2.offset;
  //         this.paginationData2 = this.serverService.pagination({'offset':response.Offset, 'total':response.Total, 'page_limit' :this.pageLimit2 });
  //          console.log(this.paginationData);
  //                 this.recordNotFound2 = this.closetickets.length == 0 ? true : false;



  //       }, 
  //       (error)=>{
  //           console.log(error);
  //       });

  // }


  listDataInfo2(list_data) {
    console.log(list_data)
    list_data.search_text = list_data.search_text == undefined ? "" : list_data.search_text;
    // list_data.order_by_name = list_data.order_by_name == undefined ? "user.user_id" : list_data.order_by_name;
    // list_data.order_by_type = list_data.order_by_type == undefined ? "desc" : list_data.order_by_type;
    list_data.limit = list_data.limit == undefined ? this.pageLimit2 : list_data.limit;
    list_data.offset = list_data.offset == undefined ? 0 : list_data.offset;
    return list_data;
  }

  getsearch2(searchValue: string): void {
    console.log(searchValue);
    this.newticket({ 'search_text': searchValue })
  }

  createticket() {
    this.files = [];
    this.filesend = [];
    this.file = null;
    tinymce.get('richTextAreacreated').setContent('');
    let api_reqs:any = '{"type": "create_ticket"}';
    this.serverService.createticket.next(api_reqs);
    
    $('#addNewPopup').modal('show');
  }


  countryflag() {

    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    data.action = "customer_data";
    data.customer_id = customer_id;

    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        this.customerdetails = response.customer_data;
        this.datadetails = response;
        this.createinformation.patchValue({

          fromticket: this.customerdetails.customerName,
          //department:"Support_SG"
          department: localStorage.getItem('dept_name')

        });
      }
      else {

      }
    },
      (error) => {
        console.log(error);
      });

  }
  jiraDropdown() {

    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    data.action = "omni_dropdown";
    data.customer_id = customer_id;

    datasend.access_token = access_token;
    datasend.operation = "omniCurl";
    datasend.moduleType = "ticket";
    datasend.api_type = "web";
    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        
        this.countryList=response.country;
        this.priorityList=response.priority;
        this.supportRequestTypeList=response.type;
       
      }
      else {

      }
    },
      (error) => {
        console.log(error);
      });

  }





  createnewticket() {

    // consoless.log(atob(this.createinformation.value.messages))
    // setTimeout(() => {
      // this.newticket({})
    // }, 2000);
    
    Swal.fire('Please wait')
    Swal.showLoading()
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');
    let cms_login_email =  localStorage.getItem('cms_login_email');
    // var department_id = localStorage.getItem('dept');
    var department_id = '103';
    const forms = new FormData();
    var msg_id = tinymce.get('richTextAreacreated').getContent();
    forms.append('name', this.customerdetails.customerName);
    // forms.append('email', this.datadetails.email_id);
    forms.append('email', cms_login_email);
    forms.append('email', this.datadetails.email_id);
    forms.append('dept_id', department_id);
    forms.append('customer_contact', localStorage.getItem('customer_contact'));
    forms.append('country_id',  this.createinformation.value.country);
    forms.append('priority_id',  this.createinformation.value.priority);
    forms.append('typeid',  this.createinformation.value.requestType);
    forms.append('subject', this.createinformation.value.subject);
    // forms.append('message', this.createinformation.value.messages.replace(/<(?:.|\n)*?>/gm, ' '));
    forms.append('message', msg_id);
    // forms.append('custs_id',  this.datadetails.customer_id);
    forms.append('custs_id', customer_id);
    forms.append('custs_code', this.customerdetails.customerCode);

    for (var i = 0; i < this.filesend.length; i++) {
      forms.append('attachment[' + i + ']', this.filesend[i]);
    }


    // forms.append('attachment', this.file);
    // forms.append('action_info', 'add_ticket');
    // forms.append('action', 'create_ticket');
    // forms.append('operation', 'curlData');
    // forms.append('access_token', access_token);
    // forms.append('moduleType', 'login');
    // forms.append('api_type', 'web');


    forms.append('action', 'cms_create_ticket');
    forms.append('access_token', access_token);
    forms.append('api_type', 'web');

    console.log(forms);
    var self = this;
    $.ajax({
      url: "https://erp.cal4care.com/cms_new/api_cms/v1.0/index_new.php",
      type: 'POST',
      data: forms,
      processData: false,  // tell jQuery not to process the data
      contentType: false,
      success: function (data) {
        console.log(data)

        self.open_ticket({})
        self.newticket({})
        self.close_ticket({})
        self.ticket_count()
        $('#addNewPopup').modal('hide');
        Swal.close();
        iziToast.success({
          message: "Ticket Created Successfully",
          position: 'topRight'
        });
        console.log("Hello from setTimeout");

      }
    });
    






  }



  ticket_count() {

    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    datas.action = "omni_ticketCount";
    // datas.customer_id = 'MzQ5';
    datas.customer_id = customer_id;


    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "ticket";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response.status == "true") {
        this.counts = response.counts;

      }
      else {
        this.counts = {};

      }

    },
      (error) => {
        console.log(error);
      });

  }

  selectDisplay(e, type) {

    $(".tile").click(function () {
      $(".tile").removeClass("inactive-menu");
      $(".tile").removeClass("active-filter");
      $(this).addClass("active-filter");
    });


    if (type == 'open-counts') {
      this.open_ticket({});
    }

    if (type == 'queue-counts') {
      this.newticket({});
    }

    if (type == 'close-counts') {
      this.close_ticket({});
    }

  }


  onMessageSend($event) {
    if ($event.keyCode != '') {

      // alert('1212')
      // this.sendChatMessageData();
      $event.stopPropagation();
      return false;
    }


  }
  initTiny() {
    var richTextArea_id = 'richTextAreacreated';
    tinymce.init({
      selector: '#richTextAreacreated',
      height: 500,
      plugins: 'advlist autolink textcolor formatpainter lists link  image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste  wordcount autolink lists media table',
      toolbar: 'undo redo |fullscreen|forecolor backcolor| formatselect | bold italic | \ undo redo | link image file| code | \
       alignleft aligncenter alignright alignjustify | \
       bullist numlist outdent indent | autoresize',
      paste_data_images: true,
      images_upload_url: 'upload.php',
      automatic_uploads: false,
      default_link_target: "_blank",
      extended_valid_elements: "a[href|target=_blank]",
      link_assume_external_targets: true,
      images_upload_handler: function (blobInfo, success, failure) {
        var xhr, formData;

        xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('POST', 'upload.php');

        xhr.onload = function () {
          var json;

          if (xhr.status != 200) {
            failure('HTTP Error: ' + xhr.status);
            return;
          }

          json = JSON.parse(xhr.responseText);

          if (!json || typeof json.file_path != 'string') {
            failure('Invalid JSON: ' + xhr.responseText);
            return;
          }

          success(json.file_path);
        };

        formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());

        xhr.send(formData);
      },
    });
    if (tinymce.editors.length > 0) {
      //  tinymce.execCommand('mceFocus', true, richTextArea_id );       
      tinymce.execCommand('mceRemoveEditor', true, richTextArea_id);
      tinymce.execCommand('mceAddEditor', true, richTextArea_id);
    }
  }


}


